// @ts-check

class FormHandler {
    /**
     * initialize all listeners for the form and update initial state
     *
     * @param {Element} container
     */
    initOnContainer(container) {
        container.querySelectorAll("[name=g-recaptcha-response]").forEach((element) => {
            if (element instanceof HTMLTextAreaElement) {
                element.required = true;
            }

            setInterval(() => {
                element.dispatchEvent(new Event("change"));
            }, 1000);
        });

        /* set php form validation errors as html5 validation errors */
        this.checkValidationResults(container);

        /* set option "null" to empty string */
        container.querySelectorAll("option").forEach((option) => {
            if (option.value == "null") option.value = "";
        });

        container.querySelectorAll(".switch .slider").forEach((checkboxControl) => {
            checkboxControl.addEventListener('click', () => {
                const label = checkboxControl.parentElement?.parentElement?.querySelector("label");
                label?.click();
            });
        });

        /* add event listeners */
        container.querySelectorAll("input").forEach((input) => {
            this.validityListeners(input);

            if (["text", "number", "email", 'tel'].includes(input.type)) {
                this.labelAnimationListeners(input);
            }

            if (input.type == "checkbox") {
                this.checkboxListeners(input, container);
            }

            if (input.type == "radio") {
                input.addEventListener("click", (_event) => {
                    document.querySelectorAll(`input[name="${input.name}"][type="radio"]`).forEach((radio) => {
                        radio.dispatchEvent(new Event("change"));
                    });
                });
            }
        });

        container.querySelectorAll("textarea").forEach((input) => {
            this.validityListeners(input);
            this.labelAnimationListeners(input);
        });

        container.querySelectorAll("select").forEach((select) => {
            this.validityListeners(select);
        });

        /* trigger events for label / checkbox content */
        container.querySelectorAll("input, select, textarea").forEach((input) => {
            setTimeout(() => {
                if (input instanceof HTMLInputElement && input.type == "checkbox") {
                    if (!input.checked) return;
                    input.parentNode?.parentNode
                        ?.querySelectorAll(".toggle-text")
                        .forEach((toggle) => {
                            toggle.classList.add("active");
                        });
                }

                input.dispatchEvent(new Event("change"));
                input.dispatchEvent(new Event("focusin"));
                input.dispatchEvent(new Event("blur"));
            }, 10);

            setTimeout(() => {
                /* duplicate of labelAnimationListeners => bugfix for loading state */
                if (input instanceof HTMLInputElement) {
                    input.parentNode?.querySelectorAll("label").forEach((label) => {
                        label.classList.add("animated-label-up");

                        if (
                            input.value.length == 0 &&
                            input.type != "date" &&
                            input.type != "hidden" &&
                            !input.validity.badInput
                        ) {
                            setTimeout(() => label.classList.remove("animated-label-up"), 10);
                        }
                    });
                }
            }, 100);
        });

        /* update required fields for hidden content */
        setTimeout(() => this.updateRequiredFields(document.querySelectorAll('.d-none'), false), 10);


        const form = container.querySelector("form");
        if (form instanceof HTMLFormElement) {

            /** @type {HTMLButtonElement|null} */
            const submitBtn = container.querySelector("button[type='submit']");
            if (submitBtn) {
                submitBtn.addEventListener("click", (_event) => {
                    if (!form.checkValidity()) {
                        // focus on first element
                        const messageContainer = form.querySelector('[id^="errormessage"]');
                        if (messageContainer instanceof HTMLElement) {
                            messageContainer.innerText = `Überprüfe das Formular. Es wurden nicht alle Felder richtig ausgefüllt.`;
                            messageContainer.classList.remove("display-none");
                            messageContainer.classList.add("alert-danger");
                            messageContainer.classList.add("alert");
                            messageContainer.scrollIntoView({ behavior: "smooth", block: "center" });
                        }
                        const firstInput = form.querySelector('input:not([type="hidden"])');
                        if (firstInput instanceof HTMLInputElement) {
                            firstInput.focus();
                        }

                    }

                    form.classList.add("was-validated");
                });
            } else {
                return console.error("FormHandler: submit button not found");
            }

            form.addEventListener('invalid', (event) => {
                event.preventDefault();
            }, true);
        }
    }

    /**
     * set php form validation errors as html5 validation errors
     * @param {Element} container
     */
    checkValidationResults(container) {
        const validationErrors = container.querySelectorAll(".validationError");

        if (validationErrors.length > 0) {
            const form = container.querySelector("form");
            if (form instanceof HTMLFormElement) form.classList.add("was-validated");
        }

        validationErrors.forEach((errorElement) => {
            if (!(errorElement instanceof HTMLElement)) return;

            let path = errorElement.dataset.path?.split('.')[1];
            const errorMessages = errorElement.innerText.split("\n").filter((message) => message.trim().length > 0).join("\n");

            if (path == undefined) return;
            if (path == "eMail") path = "e_mail";

            const input = container.querySelector('#' + path);

            if (input instanceof HTMLInputElement) input.setCustomValidity(errorMessages.trim());
        });
    }

    /**
     * update required fields when showing / hiding a container
     *
     * @param {HTMLInputElement|NodeList|HTMLSelectElement} target
     * @param {boolean} status
     */
    updateRequiredFields(target, status) {
        /**
         * @param {HTMLInputElement|HTMLSelectElement} input,
         * @param {boolean} status
         * */
        const updateInput = (input, status) => {
            if (status) {
                if (input.classList.contains("js-required")) input.required = true;
            } else if (input.required) {
                input.classList.add("js-required");
                input.required = false;
            }
        };

        if (target instanceof HTMLInputElement || target instanceof HTMLSelectElement) updateInput(target, status);

        if (target instanceof NodeList) {
            target.forEach((target) => {
                if (!(target instanceof HTMLElement)) return console.error("FormHandler: target not found");

                target.querySelectorAll("input, select").forEach((input) => {
                    if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) updateInput(input, status);
                });
            });
        }
    }

    /**
     * label animation listeners, sets class animated-label-up
     * - on focusin
     * - on blur
     *
     * @param {HTMLTextAreaElement|HTMLInputElement} input
     */
    labelAnimationListeners(input) {
        const fnLabelAnimationUp = () => {
            input.parentNode?.querySelectorAll("label").forEach((label) => {
                label.classList.add("animated-label-up");
            });
        };

        const fnLabelAnimation = () => {
            input.parentNode?.querySelectorAll("label").forEach((label) => {
                if (input.value.length != 0) return;
                if (input.validity.badInput) return;
                if (input.type == "date") return;

                label.classList.remove("animated-label-up");
            });
        };

        input.addEventListener("focusin", (_event) => { fnLabelAnimationUp(); });
        input.addEventListener("blur", (_event) => { fnLabelAnimation(); });
        input.addEventListener("onautocomplete", (_event) => { fnLabelAnimationUp(); });
    }

    /**
     * checkbox listeners for showing / hiding containers
     * values for selectors are stored in the data attributes
     * - dataset.showonactive
     * - dataset.showoninactive
     *
     * @param {HTMLInputElement} input
     * @param {Element} container
     */
    checkboxListeners(input, container) {
        input.addEventListener("change", (_event) => {

            const wrapContainer = input.parentNode?.parentNode;

            if (wrapContainer && wrapContainer instanceof HTMLElement && wrapContainer.classList.contains("fieldwrap")) {
                wrapContainer.querySelectorAll(".toggle-text").forEach((toggle) => {
                    if (input.checked) return toggle.classList.add("active");
                    toggle.classList.remove("active");
                });
            }

            if (input.dataset.showonactive) {
                const dataTarget = container.querySelectorAll(input.dataset.showonactive);

                this.updateRequiredFields(dataTarget, input.checked);

                dataTarget.forEach((target) => { target.classList.add("d-none"); });

                if (input.checked)
                    dataTarget.forEach((target) => {
                        target.classList.remove("d-none");
                        target
                            .querySelectorAll('input[type="checkbox"]')
                            .forEach((checkbox) => {
                                checkbox.dispatchEvent(new Event("change"));
                            });
                    });
            }

            if (input.dataset.showoninactive) {
                const dataTarget = container.querySelectorAll(input.dataset.showoninactive);

                this.updateRequiredFields(dataTarget, !input.checked);

                dataTarget.forEach((target) => { target.classList.add("d-none"); });

                if (!input.checked)
                    dataTarget.forEach((target) => {
                        target.classList.remove("d-none");
                        target
                            .querySelectorAll('input[type="checkbox"]')
                            .forEach((checkbox) => {
                                checkbox.dispatchEvent(new Event("change"));
                            });
                    });
            }
        });
    }

    /**
     * add html validation errors as text to the container (span.error)
     * - on invalid
     * - on keyup
     * - on change
     * check for these data attributes on the input and sets it on the container
     * - data-custom-error-message
     * - data-custom-error-class
     *
     * @param {HTMLTextAreaElement|HTMLInputElement|HTMLSelectElement} input
     */
    validityListeners(input) {
        /**
         * @param {HTMLElement|null|undefined} container,
         * @param {HTMLTextAreaElement|HTMLTextAreaElement|HTMLInputElement|HTMLSelectElement} input,
         * @param {boolean} checkValidity
         * */
        const updateErrorState = (container, input, checkValidity = false) => {
            if (!(container instanceof HTMLElement)) return console.error("FormHandler: container not found");
            if (checkValidity) input.checkValidity();

            const customErrorMessage = input.dataset?.customErrorMessage;
            const customErrorClass = input.dataset?.customErrorClass;

            if (input.validationMessage) {
                container.classList.add("has-error");
            } else {
                container.classList.remove("has-error");
            }

            let errorElement = container.querySelector('.error');
            if (!(errorElement instanceof HTMLElement)) {
                const newElement = document.createElement("span");
                newElement.classList.add("error");
                newElement.setAttribute("id", "error" + input.id);
                container.insertAdjacentElement("beforeend", newElement);

                errorElement = container.querySelector('.error');
            }

            if (errorElement instanceof HTMLElement) {
                if (customErrorClass) errorElement?.classList.add(customErrorClass);

                if (customErrorMessage) return errorElement.innerText = customErrorMessage;
                errorElement.innerText = input.validationMessage;
            }
        };

        if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
            /** @type {HTMLElement|null|undefined} */
            let parent = input.parentElement;
            if (!parent) return;

            // check if input is type of checkbox
            if (input.type === "checkbox") {
                parent = input.parentElement?.parentElement?.parentElement;
            }

            // radios of a group share a single error message -> attach it to
            // the wrapper around the radiogroup instead of each option label,
            // so the error is rendered only once per group (not per radio).
            if (input.type === "radio") {
                parent = input.closest('[role="radiogroup"]')?.parentElement ?? input.parentElement;
            }

            if (!parent) return;

            input.addEventListener("invalid", (_event) => updateErrorState(parent, input));
            input.addEventListener("keyup", (_event) => updateErrorState(parent, input, true));
            input.addEventListener("change", (_event) => updateErrorState(parent, input, true));
        }
    }


    /**
     * sort options of a select element alphabetically
     * replaces special characters: Ä, Ö, Ü, ß
     *
     * @param select {HTMLSelectElement}
     */
    sortSelectOptions(select) {
        if (!select.options) return;

        const options = Array.from(select.options);

        /**
         * @param {string} text
         * @return {string}
         */
        const parseText = (text) => {
            text = text.toUpperCase();

            text = text.replace(/Ä/g, 'AE');
            text = text.replace(/Ö/g, 'OE');
            text = text.replace(/Ü/g, 'UE');
            text = text.replace(/ß/g, 'SS');
            text = text.replace(/Å/g, 'AA');
            return text;
        };

        options.sort((a, b) => {
            const textA = parseText(a.text);
            const textB = parseText(b.text);

            if (a.value === "") return -1;
            if (a.value === "") return 1;

            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        select.innerHTML = '';

        options.forEach(option => select.add(option));
    }

    /**
     * validate: <input type="text" inputmode="numeric">
     * - on keyup
     * option to allow negative numbers (default: false)
     * input only allows int values
     * validation:
     * - set value to 0 if empty str
     * - remove leading 0
     * - stripe non number chars
     *
     * @param {HTMLInputElement} inputElement
     * @param {boolean} allowNegative
     */
    validateNumericTextInputEvListener(inputElement, allowNegative = false) {
        inputElement.dispatchEvent(new Event("keyup"));

        inputElement.addEventListener("keyup", () => {
            const _strStartsWithMinus = inputElement.value.startsWith("-");

            // strip non int chars
            const currentValueStr = inputElement.value.replace(/[^0-9]/g, '');

            let newValueStr = currentValueStr;

            // set 0 if empty or invalid
            const _isEmptyStr = currentValueStr == "";
            const _isNegativeInt = parseInt(currentValueStr) < 0;
            const _isNanStr = currentValueStr == "NaN";
            if (_isEmptyStr || _isNanStr || (_isNegativeInt && !allowNegative)) newValueStr = "0";

            // add minus if needed
            if (_strStartsWithMinus && allowNegative) newValueStr = "-" + newValueStr;

            // removed leading 0
            newValueStr = parseInt(newValueStr).toString();

            // set new value
            if (inputElement.value != newValueStr) inputElement.value = newValueStr;
        });
    }
}

globalThis.WpFormHandler = new FormHandler();
